export const SET_KEY_FORM = 'SET_KEY_FORM';
export const TRIGGER_KYC_POST = 'TRIGGER_KYC_POST';

export const triggerKycPost = (formData: any) => ({
    form: {},
    type: TRIGGER_KYC_POST,
});

export function setKeyForm() {
    return {
        type: SET_KEY_FORM,
    };
}
